<template>
  <div class="privacy-container">
    <anchor class="privacy-navigator">
      <anchor-link href="#section1" title="1. 账户" />
      <anchor-link href="#section2" title="2. 服务内容" />
      <anchor-link href="#section3" title="3. 内容和行为规范" />
      <anchor-link href="#section4" title="4. 个人信息及隐私保护" />
      <anchor-link href="#section5" title="5. 软件使用许可条款" />
      <anchor-link href="#section6" title="6. 版权保护" />
      <anchor-link href="#section7" title="7. 商标及相关权利" />
      <anchor-link href="#section8" title="8. 违约处理" />
      <anchor-link href="#section9" title="9. 服务的修改和终止" />
      <anchor-link href="#section10" title="10. 有限责任" />
      <anchor-link href="#section11" title="11. 适用法律" />
      <anchor-link href="#section12" title="12. 争议" />
      <anchor-link href="#section13" title="13. 条款修改和可分性" />
      <anchor-link href="#section14" title="14. 其他" />
    </anchor>

    <privacy-content></privacy-content>
    <footer class="agreeButton">
      <button :class="{ agreeBg: this.agree === 0 }" @click="changeAgree(0)">
        暂不同意
      </button>
      <button :class="{ agreeBg: this.agree === 1 }" @click="changeAgree(1)">
        同意
      </button>
    </footer>
  </div>
</template>

<script>
import anchor from './components/anchor.vue'
import anchorLink from './components/anchorLink.vue'
import privacyContent from './components/serviceContent.vue'

export default {
  components: {
    anchor,
    anchorLink,
    privacyContent
  },
  data() {
    return {
      container: () => document.querySelector('body'),
      agree: 2
    }
  },
  methods: {
    changeAgree(val) {
      this.agree = val
      this.$notify({
        title: '温馨提示',
        type: val === 1 ? 'success' : 'warning',
        message:
          val === 1
            ? '您已同意该服务协议，请点击左上角返回登录继续操作'
            : '若您不同意该服务协议，很遗憾我们将无法为您提供服务。'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/privacy.scss';
.agreeButton {
  position: fixed;
  width: 100%;
  height: 50px;
  z-index: 999;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  button {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    border: none;
    -webkit-appearance: none;
    outline: none;
    background: #eee;
  }
  button:first-child {
    box-sizing: border-box;
    border-right: 1px solid #999;
  }
  .agreeBg {
    background: lightblue;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/privacyCloud/service.vue